<template lang="pug">
  v-flex(xs12 sm6 md4).card-content
    v-card.marketing-card.mb-3
      v-container
        v-layout(row)
          v-flex(shrink icon)
            slot(name="icon")
          v-flex(title-container)
            div.title(:class="properties.headlineClass") {{ properties.title }}
              slot(name="chip")
            div {{ properties.subTitle }}
      v-divider(light)
      v-card-title
        v-flex.body {{ properties.text }}
      v-flex.text-center
        slot(name="actions")
</template>
<script>
export default {
  name: 'MarketingIndex',
  props: {
    properties: Object,
  },
};
</script>
<style lang="scss" scoped>
.card-content {
  display: flex;
  flex-flow: row wrap;
  .container {
    padding: 10px;
    min-height: 60px;
  }
  .v-card__title {
    align-items: flex-end;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.01em;
    font-size: 18px;
    white-space: pre-wrap;
  }
  .body {
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.01em;
    white-space: pre-wrap;
  }
  .text-center {
    text-align: center;
    height: 20%;
  }
  .icon {
    display: flex;
    justify-content: flex-start;
  }
  .title-container {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
